import {useHistory} from "react-router";
import RegisterLayout from '@/layout/RegisterLayout'
import style from './Resiger.scss'
import globalStyle from '@/styles/Global.scss'
import MButton from "@/components/atom/MButton";
import React, {useState} from "react";
import {UserRegister} from "@/entity/User";

const Register = () => {
  const history = useHistory()
  const [userRegister, setUserRegister] = useState(new UserRegister({}))

  const toConfirm = () => {
    history.push('/register/confirm', {userRegister})
  }

  const updateUserRegister = (diff) => {
    setUserRegister(new UserRegister({...userRegister, ...diff}))
  }

  const goBack = () => {
    history.push('/register/apply')
  }

  const substitutePasswordAsEmail = () => {
    console.log(userRegister)
    setUserRegister(new UserRegister({...userRegister, password: userRegister.mail, password2: userRegister.mail}))
  }
  const substitutePassword = () => {
    setUserRegister(new UserRegister({...userRegister, password: 'password', password2: 'password'}))
  }

  return (
    <>
      <RegisterLayout>
        <div className={globalStyle.attribute}>
          <h3>登録</h3>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>メールアドレス</div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.mail}
                   onInput={(e) => updateUserRegister({mail: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            メールアドレス(再入力){userRegister.unMatchMail() &&
            <span className={style.unMatch}>同じメールアドレスを入力してください</span>}
          </div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.mail2}
                   onInput={(e) => updateUserRegister({mail2: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div style={{ marginLeft: '10px' }}>
            パスが思いつかない方は下記「ボタン」をクリックしてください。
          </div>
          <div style={{ marginLeft: 0 }}>
            <div style={{ marginLeft: '10px', marginBottom: '10px', marginTop: '10px', fontWeight: 'bold', color: '#0a58ca', cursor: 'pointer' }}>
              <span onClick={substitutePasswordAsEmail}>メールアドレスをパスワードに代用する</span>
            </div>
            <div style={{ marginLeft: '10px', marginBottom: '10px', fontWeight: 'bold', color: '#0a58ca', cursor: 'pointer' }}>
              <span onClick={substitutePassword}>passwordで代用する</span>
            </div>
          </div>
          <div className={globalStyle.title}>
            パスワード{userRegister.invalidPassword() &&
            <span className={style.unMatch}>パスワードは8文字以上で入力してください</span>}
          </div>
          <div className={globalStyle.value}>
            <input type={"password"} className={style.input} value={userRegister.password}
                   onInput={(e) => updateUserRegister({password: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>
            パスワード(再入力){userRegister.unMatchPassword() &&
            <span className={style.unMatch}>同じパスワードを入力してください</span>}
          </div>
          <div className={globalStyle.value}>
            <input type={"password"} className={style.input} value={userRegister.password2}
                   onInput={(e) => updateUserRegister({password2: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>姓</div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.familyName}
                   onInput={(e) => updateUserRegister({familyName: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>名</div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.firstName}
                   onInput={(e) => updateUserRegister({firstName: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>姓フリガナ</div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.familyNameKana}
                   onInput={(e) => updateUserRegister({familyNameKana: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div className={globalStyle.title}>名フリガナ</div>
          <div className={globalStyle.value}>
            <input className={style.input} value={userRegister.firstNameKana}
                   onInput={(e) => updateUserRegister({firstNameKana: e.target.value})}/>
          </div>
        </div>
        <div className={globalStyle.attribute}>
          <div>
            パスワードに「メールアドレスをパスワードに代用する。」もしくは「passwordで代用する。」でパスワードを作成された方は、仮のパスワードですので、変更をお願いいたします。
          </div>
          <MButton image={'kakunin.png'} value={'確認'} disabled={!userRegister.canRegister()}
                   onClick={toConfirm}></MButton>
          <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
        </div>
      </RegisterLayout>
    </>
  )
}

export default Register;
